import dayjs from 'dayjs';

import { PAGE_SIZE } from './constants';

/** 발행일을 'N일/주/달/년 전' 한국어 라벨로 변환한다. 잘못된 값은 빈 문자열. */
export const formatDateLabel = (date?: string) => {
  if (!date) return '';
  const target = dayjs(date);
  if (!target.isValid()) return '';

  const days = Math.max(
    dayjs().startOf('day').diff(target.startOf('day'), 'day'),
    0,
  );
  if (days < 7) return `${days}일 전`;
  if (days < 30) return `${Math.floor(days / 7)}주 전`;
  if (days < 365) return `${Math.floor(days / 30)}달 전`;

  return `${Math.floor(days / 365)}년 전`;
};

/** 종료일까지 남은 일수를 반환한다. 이미 지났거나 잘못된 값이면 0. */
export const calcDaysLeft = (endDate?: string) => {
  if (!endDate || !dayjs(endDate).isValid()) return 0;

  return Math.max(
    dayjs(endDate).startOf('day').diff(dayjs().startOf('day'), 'day'),
    0,
  );
};

/** 정책 신청기간을 'YYYY.MM.DD ~ MM.DD' 형식으로 포맷한다. 양쪽 다 없으면 '상시 모집'. */
export const formatApplicationPeriod = (start?: string, end?: string) => {
  if (!start && !end) return '상시 모집';
  if (!start) return `~ ${dayjs(end).format('YYYY.MM.DD')}`;
  if (!end) return `${dayjs(start).format('YYYY.MM.DD')} ~`;

  return `${dayjs(start).format('YYYY.MM.DD')} ~ ${dayjs(end).format('MM.DD')}`;
};

/** 콤마로 구분된 쿼리 문자열을 trim된 string 배열로 파싱한다. 빈 토큰은 제외. */
export const parseStringList = (value: string | null): string[] => {
  if (!value) return [];

  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

/** 콤마로 구분된 쿼리 문자열을 number 배열로 파싱한다. NaN/Infinity는 제외. */
export const parseNumberList = (value: string | null): number[] =>
  parseStringList(value)
    .map((item) => Number(item))
    .filter((parsedValue) => Number.isFinite(parsedValue));

/** 쿼리 값이 허용 옵션에 포함되면 그대로, 아니면 default 값을 반환한다 (정렬/탭 등 enum 파싱용). */
export const parseEnumValue = <T extends string>(
  value: string | null,
  options: readonly T[],
  defaultValue: T,
): T => (value && options.includes(value as T) ? (value as T) : defaultValue);

/** 배열에 항목이 있으면 제거, 없으면 추가한 새 배열을 반환한다 (체크박스/칩 토글). */
export const toggleArrayItem = <T>(list: T[], item: T): T[] =>
  list.includes(item)
    ? list.filter((value) => value !== item)
    : [...list, item];

/** totalCount로부터 PAGE_SIZE 기준 페이지네이션 메타({ totalCount, totalPages })를 만든다. */
export const buildPaginationMeta = (totalCount?: number) => ({
  totalCount,
  totalPages:
    totalCount === undefined ? undefined : Math.ceil(totalCount / PAGE_SIZE),
});
